import { render, staticRenderFns } from "./form.vue?vue&type=template&id=10e01656&scoped=true&"
import script from "./form.vue?vue&type=script&lang=babel&"
export * from "./form.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e01656",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VForm,VTabs})
